import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'
import Grid from '../components/Grid'
import styled from 'styled-components'

const PlaylistLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`

export default class SEEVideoExamples extends Component {
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="SEE Video Examples" backHref="/resources" backText="Resources">
          <Card>
            <Card.Pad>
              <Paragraph str="Below are links to YouTube playlists of counselor training videos. Please use these videos to learn how patient counseling sessions may be conducted." />
            </Card.Pad>
          </Card>
          <Grid>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TU_hhegodjXlvXJfpeVDMKO" target="_blank">1. Full Sessions</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TW7mjC4VLwl9G86HaTAAjGI" target="_blank">2. Elicit-Provide-Elicit</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TWhQMtDunV-BmBrs08eZbRw" target="_blank">3. Affirmation</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TU0da-5u-nByWzjQOOMD9D8" target="_blank">4. Open and Closed Questions</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TWqaJk6Cx4DvfV2IonXgy-k" target="_blank">5. Simple and Complex Reflections</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TVJ0rDlYDqb3SIN5Kvgea_6" target="_blank">6. Rulers</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TWUKPWl22X_fV9jjZJYlRx6" target="_blank">7. Planning</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TWDE3hJ2NhKDOK7gYJkqSxZ" target="_blank">8. Exploring Strengths/Values</PlaylistLink>
            </Grid.ThirdCell>
            <Grid.ThirdCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TUd8TBL2Iqw4XuAaQjopF_9" target="_blank">9. Summaries</PlaylistLink>
            </Grid.ThirdCell>
          </Grid>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SEEVideoExamples.js